module.exports = __webpack_public_path__ + "crash-forces.jpg?695dadf572b8d1d846c7ed60390daa3c";